
import { Vue, Component } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import {
  Form,
  FormItem,
  Select,
  Option,
  Input,
  Popover,
  Button,
} from 'element-ui';
import { ICategoryForm } from '@/types/asset.d';
import api from '@/api/asset';

@Component({
  components: {
    Form,
    FormItem,
    Select,
    Option,
    Input,
    Popover,
    Button,
  },
})
export default class AssetCategory extends Vue {
  @Mutation('asset/SET_ASSET_CATEGORY_LIST_FLAG') setCategoryFlg!: Function;

  private form: {[key: string]: string} = {
    categories: '',
  };

  private addForm: ICategoryForm = {
    label: '',
  };

  private categoryOpts: Array<{pid: string, label: string}> = [];

  private rules: { [key: string]: any } = {
    categories: [
      { required: true, message: '请选择素材分类', trigger: 'change' },
    ],
  };

  private addRules: {[key: string]: any} = {
    label: [
      { required: true, message: '请填写分类名称', trigger: 'change' },
    ],
  };

  private refresh: { [key: string]: boolean } = { category: false };

  private loading: { [key: string]: boolean } = { addBtn: false };

  private visible: { [key: string]: boolean } = { popover: false };

  public $refs!: {
    form: Form,
    addForm: Form,
  };

  mounted() {
    this.getCategoryOpts();
  }

  /**
   * @author Terry
   * @description 获取分类列表
   * @param { Boolean } flag 是否需要提示语
   */
  /* eslint-disable no-return-assign */
  getCategoryOpts(flag: boolean = false) {
    api.getCategoryList().then((res: any) => {
      if (flag) this.msg('获取素材分类成功 ~', 'success');
      this.categoryOpts = res;
    }).finally(() => (this.refresh.category = false));
  }

  /**
   * @author Terry
   * @description 分类刷新按钮
   */
  handleCategoryOptsRefresh() {
    this.refresh.category = true;
    this.getCategoryOpts(true);
  }

  /**
   * @author Terry
   * @description 处理分类添加按钮
   */
  /* eslint-disable no-return-assign */
  handleAddFormSubmit() {
    this.loading.addBtn = true;
    this.$refs.addForm.validate((valid: boolean) => {
      if (valid) {
        api.createCategory(this.addForm).then((res: any) => {
          this.visible.popover = false;
          this.loading.addBtn = false;
          this.$refs.addForm.resetFields();
          this.setCategoryFlg(true);
          this.getCategoryOpts();
        }).catch(() => (this.loading.addBtn = false));
      }
      this.loading.addBtn = true;
    });
  }

  /**
   * @author Terry
   * @description 处理确定按钮 返回Promise
   */
  handleFormSubmit(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.$refs.form.validate((valid: boolean) => {
        if (valid) resolve(this.form.categories);
        resolve('');
      });
    });
  }
}
